<script lang="ts">
	import AppLayout from "../layouts/AppLayout.svelte";
	import Form from "@hitit/sso/src/layouts/Form.svelte";
	//Split
	import { onMount } from "svelte";
	import { t } from "@hitit/hub/src/stores";
	import { navigate } from "svelte-routing";
	import {
		DefaultTextInput,
		DefaultButton,
		DefaultNav,
		InputFrame,
	} from "@hitit/new_ui/src";
	//
	const BACKEND_URL = "HITIT_BACKEND_URL";
	//

	let username = "";
	let password = "";

	$: error = location.search == "?error";

	onMount(() => {
		const exactReferrer = "HITIT_HUB_URL";
		const devMode = location.host.includes("localhost:3000");
		if (document.referrer !== exactReferrer && !devMode)
			location.replace(exactReferrer);

		//if referrer is not hitit_hub_url server will redirect wrong page;
		//if run dev `HITIT_HUB_URL` will replace localhost:3000
	});
</script>

<AppLayout>
	<Form method={"POST"} action={BACKEND_URL + "oauth/processlogin"} clearMode>
		<InputFrame direction={"column"}>
			<DefaultTextInput
				bind:value={username}
				id={"username"}
				placeholder={$t("sso.username")}
				error={error}
				clearButtonDisplay={username.length > 0}
				clearCallback={() => (username = "")}
			/>
			<DefaultTextInput
				bind:value={password}
				id={"password"}
				placeholder={$t("sso.password")}
				password
				error={error}
				clearButtonDisplay={password.length > 0}
				clearCallback={() => (password = "")}
			/>
		</InputFrame>
		<p id="login-error">
			{#if error}{$t("sso.error.loginError")}{/if}
		</p>
		<DefaultButton
			defaultClassname={"login-button"}
			disabled={username.length == 0 || password.length == 0}
		>
			<span class="white"> LOGIN </span>
		</DefaultButton>
		<div class="navs">
			<DefaultNav>
				<span on:click={() => navigate("/forgotId")}
					>{$t("sso.login.forgot_username")}</span
				>
			</DefaultNav>
			<DefaultNav>
				<span on:click={() => navigate("/signup")}
					>{$t("sso.login.signup")}</span
				>
			</DefaultNav>
		</div>
	</Form>
</AppLayout>

<style lang="scss">
	:global(button.login-button:disabled) {
		background-color: #a5c1f9;
	}

	#login-error {
		color: var(--error-color-1);
		box-sizing: border-box;

		padding: 8px 10px;
		height: 57px;
	}

	span.white {
		color: white;
	}

	.navs {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
	}
</style>
